import { render, staticRenderFns } from "./TeamSocialMediaMobileView.vue?vue&type=template&id=590a8df9&scoped=true&"
import script from "./TeamSocialMediaMobileView.vue?vue&type=script&lang=js&"
export * from "./TeamSocialMediaMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a8df9",
  null
  
)

export default component.exports